export const onDone = creds => ({
  widget: 'changePass',
  type: 'onDone',
  payload: { creds },
})



// WEBPACK FOOTER //
// ./src/change-pass/actions/onDone.js